(function ($, Drupal, once) {
  // eslint-disable-next-line no-param-reassign
  Drupal.behaviors.subnav = {
    attach(context) {
      once('nav-main', '.m-nav-main', context).forEach(function (elem) {

        const component = $(elem);
        const navItems = component.find('.m-nav-main__item--has-sub');
        const navItemHasSub = component.find('.m-nav-main__item--has-sub .m-nav-main__link');
        const openButton = component.find('.m-nav-main__link');

        openButton.attr('aria-expanded', 'false');

        function openSubnav(target) {
          target.addClass('m-nav-main__item--sub-open');
        }
        
        function closeSubnav(target) {
          target.removeClass('m-nav-main__item--sub-open');
        }

        function isDesktop() {
          return $(window).width() > 991;
        }
        
        function clickHandler(event) {
          
          const target = $(event.target);
          const parent = $(target).parents('.m-nav-main__item');

          if (parent.hasClass('m-nav-main__item--has-sub')) {
            event.preventDefault();

            if (parent.hasClass('m-nav-main__item--sub-open')) {
              closeSubnav(parent);
            } else {
              openSubnav(parent);
            }
          }
        }

        function enterHandler(event) {
          if (isDesktop()) {
            const parent = $(event.target).closest('.m-nav-main__item');
            openSubnav(parent);
          }
        }

        function leaveHandler(event, target) {
          if (isDesktop()) {
            const mousedItem = $(target);
            // Check if the mouse is moving to a child element
            const relatedTarget = $(event.relatedTarget);
            if (!relatedTarget.closest('.m-nav-main__item--has-sub').is(mousedItem)) {
              closeSubnav(mousedItem);
            }
          }
        }

        navItemHasSub.on('click', clickHandler);
        navItems.on('mouseenter', function(event) {
          enterHandler(event);
        });
        navItems.on('mouseleave', function(event) {
          leaveHandler(event, $(this));
        });

         // TODO: Add focus and mouse handlers
      });
    },
  };
  // eslint-disable-next-line no-undef
})(jQuery, Drupal, once);
